/* eslint-disable camelcase */
import { handleActions } from 'redux-actions';
import {
  domainsListFetchInitialized,
  domainsListFetchSucceeded,
  domainsListFetchFailed,
} from '../DomainsService';

export const PIWIK_BUILT_IN_DOMAINS = ['default.piwik.pro', 'default.containers.piwik.pro'];

export type DomainsListResponse = Domain[]

export type CertificateStatus = {
  name: 'valid' | 'invalid' | 'expired' | 'processing'
  reason: string
};
type Certificate = {
  status: CertificateStatus
  expires: string | null
};

export type DomainTypes = 'ui_apis' | 'static_resources' | 'tracking_dynamic_endpoints'

export interface Domain {
  domain: string
  types: DomainTypes[]
  status: 'active' | 'inactive'
  certificate: Certificate
  is_built_in: boolean
}

export interface DomainsListState {
  isLoading: boolean
  failed: boolean
  list: Domain[]
}

const initialState: DomainsListState = {
  isLoading: true,
  failed: false,
  list: [],
};

export default handleActions<DomainsListState, Domain[]>({
  [domainsListFetchInitialized.toString()]: () => initialState,
  [domainsListFetchSucceeded.toString()]: (
    state,
    { payload },
  ) => ({
    ...state,
    isLoading: false,
    failed: false,
    list: payload,
  }),
  [domainsListFetchFailed.toString()]: state => ({
    ...state,
    isLoading: false,
    failed: true,
    list: [],
  }),
}, initialState);
